import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, catchError, of } from 'rxjs';
import { StorageService } from 'src/app/_services/storage.service';
import { environment } from 'src/environments/environment';
const { API_URLBLAZE} = environment;

@Injectable({
  providedIn: 'root'
})

export class CountryMasterService {

    constructor(private http: HttpClient, private storageService: StorageService, private router: Router) { }

    //Update Country By Country Code
    updateCountryByCode(countryData: any):Observable<any> {
      const url = `${API_URLBLAZE}/product/country`;
      return this.http.post(url, countryData).pipe(catchError(this.handleError()));
    }

    //Get Country List All with Pagination
    getCountryListAll(countryName:String,riskRating:String,score:String,label:string,page_size:number|string,page_no:number) {
      var url = "";
      var filter = "";
      if(countryName != ""){
        filter = filter+`&name=${countryName}`
      }
      if(riskRating != "" && riskRating !=null){
        filter = filter+`&rating.name=${riskRating}`
      }
      if(score != "" && score != null){
        filter = filter+`&score=${score}`
      }
      url = `${API_URLBLAZE}/product/country?page_size=${page_size}&page_no=${page_no}`+filter;
      console.log(url);
      return this.http.get(url).pipe(catchError(this.handleError()));
    }

    //Get Rating List
    getRatingList() {
      const url = `${API_URLBLAZE}/product/rating`;
      return this.http.get(url).pipe(catchError(this.handleError()));
    }

    //Get Label List
    getLabelList() {
      const url = `${API_URLBLAZE}/product/country-label`;
      return this.http.get(url).pipe(catchError(this.handleError()));
    }

    //Get Flag Image
    getFlagImage(flagName: any) {
      const url = `${API_URLBLAZE}/product/icon/get-profile?url=/country/${flagName}`;
      return this.http.get(url, { responseType: 'blob' as 'json' }).pipe(catchError(this.handleError()));
    }
    
    //Update Rating List
    updateRatingList(ratingData:any) {
      const url = `${API_URLBLAZE}/product/rating`;
      return this.http.post(url,ratingData).pipe(catchError(this.handleError()));
    }

    //Update Label List
    updateLabelList(labelList:any) {
      const url = `${API_URLBLAZE}/product/country-label`;
      return this.http.post(url,labelList).pipe(catchError(this.handleError()));
    }

    //Delete Label List
    deleteLabelByName(label:any) {
      const url = `${API_URLBLAZE}/product/country-label/${label}`;
      return this.http.delete(url).pipe(catchError(this.handleError()));
    }

      private handleError<T>(operation = 'operation', result?: T) {
        return (error: HttpErrorResponse): Observable<T> => {
          if (error.status == 401) {
            this.storageService.clean()
            this.router.navigate(['/auth/login']);
          }
          result = error?.error;
          return of(result as T);
        };
      }
}